module.exports = __webpack_public_path__ + "static/nica-9629c17b6c074ef9dc55f9f753322db7.png";